import { $host } from './index';
import {
  paymentDetailsAC,
  bankBicsAC,
  searchedSwiftAC,
  exchangeXrateAC,
  feeRateAC,
  feeAmountAC,
  asycudaInnInfoAC,
  isAsycudaInnValidAC,
} from '@store/reducers/payments';
import { isSpinAC, notificationModalAC } from '@store/reducers/app';
import { AppDispatch } from '@store';
import { deadlineAC, otpConfirmAC, verifyTransIdAC } from '@store/reducers/transactions';
import { handleArrayBufferErrors } from '@utils/handleError';

const END_POINT = '/client';

const getBankBicsApi = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/search-bic`);
    dispatch(bankBicsAC(data));
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const searchSwiftApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/search-swift`, params);
    dispatch(searchedSwiftAC(data));
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const swiftTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/swift`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/swiftPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const swiftTjsTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/swift/tjs`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/swiftTjsPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const swiftRubTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/swift/rub`, params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/swiftRubPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const ownAccountTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/own-account`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/ownAccountsPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const internalTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/internal`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/internalPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const interbankTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/interbank`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/interbankPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const exchangeTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/fx/init`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/exchangePaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const electricTransactionApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/utils/payment`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/exchangePaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getElectricClientInfoApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/utils/client-info`, params);

    return data;
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getExchangeRateApi = (params: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/fx/rate`, params);
    if (data) {
      dispatch(exchangeXrateAC(data.xrate));
      callback(data);
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const checkFeeApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/check/fee`, params);
    if (data) {
      dispatch(feeRateAC(data.fee_rate * 100));
      dispatch(feeAmountAC(data.fee_amount));
    }
    return data;
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getPaymentDetailsApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/details`, params);
    dispatch(paymentDetailsAC(data));
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getAsycudaInnInfoApi = (inn: any) => async (dispatch: AppDispatch) => {
  if (!inn) {
    return;
  }

  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.get(`${END_POINT}/transaction/asycuda/inn?inn=${encodeURIComponent(inn)}`);
    if (data.errorCode === '15') {
      dispatch(asycudaInnInfoAC({}));
      dispatch(isAsycudaInnValidAC(false));
    } else {
      dispatch(asycudaInnInfoAC(data));
      dispatch(isAsycudaInnValidAC(true));
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const createAsycudaPaymentApi = (params: any, navigate: any, callback: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/asycuda/payment`, params);
    if (data) {
      if (data?.otp_required) {
        dispatch(otpConfirmAC(true));
        dispatch(verifyTransIdAC(data?.trans_id));
        dispatch(deadlineAC(Date.now() + 1000 * data.code_lifetime));
      } else {
        callback();
        navigate(`/asycudaPaymentStatus/${data.trans_id}`);
      }
    }
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error.response?.data?.detail,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getPaymentDetailsOrderApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const response = await $host.post(`${END_POINT}/transaction/payment/order`, params, {
      responseType: 'arraybuffer',
    });
    const dispositionHeader = response.headers['content-disposition'];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(dispositionHeader);
    let filename = '';
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
  } catch (error: any) {
    handleArrayBufferErrors(error);
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getPaymentDetailsOrderToPrintApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/payment/order`, params, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([data], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);

    const printWindow = window.open(url, '_blank');

    printWindow?.addEventListener('load', () => {
      printWindow?.print();
    });
  } catch (error: any) {
    handleArrayBufferErrors(error);
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getBulkPaymentOrderApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const response = await $host.post(`${END_POINT}/transaction/payment/order/bulk`, params, {
      responseType: 'arraybuffer',
    });
    const dispositionHeader = response.headers['content-disposition'];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(dispositionHeader);
    let filename = '';
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
  } catch (error: any) {
    handleArrayBufferErrors(error);
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getPaymentOrderApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const response = await $host.post(`${END_POINT}/transaction/bill`, params, {
      responseType: 'arraybuffer',
    });
    const dispositionHeader = response.headers['content-disposition'];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(dispositionHeader);
    let filename = '';
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    link.click();
  } catch (error: any) {
    handleArrayBufferErrors(error);
  } finally {
    dispatch(isSpinAC(false));
  }
};

const getPaymentOrderToPrintApi = (params: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/transaction/bill`, params, {
      responseType: 'arraybuffer',
    });
    const blob = new Blob([data], { type: 'application/pdf' });

    const url = URL.createObjectURL(blob);

    const printWindow = window.open(url, '_blank');

    printWindow?.addEventListener('load', () => {
      printWindow?.print();
    });
  } catch (error: any) {
    handleArrayBufferErrors(error);
  } finally {
    dispatch(isSpinAC(false));
  }
};

export {
  createAsycudaPaymentApi,
  getAsycudaInnInfoApi,
  getBulkPaymentOrderApi,
  getElectricClientInfoApi,
  electricTransactionApi,
  checkFeeApi,
  interbankTransactionApi,
  getBankBicsApi,
  searchSwiftApi,
  swiftTransactionApi,
  swiftTjsTransactionApi,
  internalTransactionApi,
  ownAccountTransactionApi,
  getPaymentDetailsApi,
  getPaymentDetailsOrderApi,
  getPaymentOrderApi,
  exchangeTransactionApi,
  getExchangeRateApi,
  getPaymentOrderToPrintApi,
  getPaymentDetailsOrderToPrintApi,
  swiftRubTransactionApi,
};
